import React from "react";
import list from "javascriptstuff-db/style-libraries";

import Page from "../../components/common/Page";
import ListPageContainer from "../../components/list/ListPageContainer";
import addNotes from "../../logic/addNotes";
import StyledTextBlock from "../../components/common/StyledTextBlock";

const extendedList = addNotes(list, {
  "gajus/react-css-modules": `This helps you set up CSS Modules in your project, but you don't need it to use CSS Modules with React.`
});

export default () => (
  <Page>
    <ListPageContainer list={extendedList}>
      <StyledTextBlock>
        <p>
          These are tools that assist with applying styles to elements. There
          are a variety of ways that this can happen.
        </p>
        <p>
          The most common type of style library is a{` `}
          <a href="#tag:'css processor'">CSS processor</a>. These take as input
          a language similar to CSS but with more features, and output standard
          CSS that the browser can understand.
        </p>
        <p>
          The other tools are more varied. They might help you manage
          <a href="#tag:'inline'">inline</a> styles, help you write your CSS in
          JavaScript, or help you keep styles isolated to a particular
          component.
        </p>
      </StyledTextBlock>
    </ListPageContainer>
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/list/style-libraries.js